import PropTypes from 'prop-types';

import { useCurrentPage } from '»utils/customHooks';

import { TrlTab } from './TrlTab/TrlTab';
import { TabsStyled, TabsWrapperStyled } from './TrlTabContainer.styles';

export const TrlTabContainer = ({
  tabs,
  value,
  handleChange,
  mainTabContainer,
  stockExchangeDetails,
  stockExchangeDetailsCurrentSlide,
  children,
  ...props
}) => {
  const { isFundsDetailsPage } = useCurrentPage();

  return (
    <TabsWrapperStyled
      id="tabsContainer"
      mainTabContainer={mainTabContainer}
      stockExchangeDetails={stockExchangeDetails}
      stockExchangeDetailsCurrentSlide={stockExchangeDetailsCurrentSlide}
      isFundsDetailsPage={isFundsDetailsPage}
      hasChildren={!!children}
      {...props}
    >
      <TabsStyled centered value={value} onChange={handleChange} showIndicator>
        {tabs?.map((tab, index) => (
          <TrlTab
            key={tab?.id || tab.label}
            id={tab?.id}
            icon={tab?.icon}
            label={tab.label}
            disabled={tab?.disabled}
            index={index}
            nTabs={tabs.length}
            {...props}
          />
        ))}
      </TabsStyled>
      {children}
    </TabsWrapperStyled>
  );
};
TrlTabContainer.propTypes = {
  tabs: PropTypes.array,
  value: PropTypes.number.isRequired,
  handleChange: PropTypes.func,
  mainTabContainer: PropTypes.bool,
  stockExchangeDetails: PropTypes.bool,
  stockExchangeDetailsCurrentSlide: PropTypes.number,
  children: PropTypes.element,
};
